import type { LanguageModel } from '@helsenorge/core-cms/types/entities/cms.v1entities';
import { VimeoSubtitleLanguageCodes } from '@helsenorge/core-cms/videospiller/constants';

export const videoLanguageMapper = (languageModels: LanguageModel[]): VimeoSubtitleLanguageCodes => {
  const language = languageModels.find(lang => lang.isCurrentLanguage === true);
  const cultureName = language?.cultureName ?? 'nb';

  switch (cultureName) {
    case 'nn':
      return VimeoSubtitleLanguageCodes.NORWEGIAN_NYNORSK;
    case 'en':
      return VimeoSubtitleLanguageCodes.ENGLISH;
    case 'se':
      return VimeoSubtitleLanguageCodes.SAMI_NORTHERN;
    case 'lt':
      return VimeoSubtitleLanguageCodes.LITHUANIAN;
    case 'pl':
      return VimeoSubtitleLanguageCodes.POLISH;
    case 'ru':
      return VimeoSubtitleLanguageCodes.RUSSIAN;
    case 'ro':
      return VimeoSubtitleLanguageCodes.ROMANIAN;
    default:
      return VimeoSubtitleLanguageCodes.NORWEGIAN;
  }
};
